const WHITE = 'whitesmoke';
const ORANGE = 'rgb(211, 142, 115)';
const BLUE = 'rgb(69, 128, 182)';
const PURPLE = 'rgb(99, 79, 148)';
const BLACK = 'black';
const GREY = 'rgb(33, 37, 41)';

module.exports = {
    WHITE, ORANGE, BLUE, PURPLE, BLACK, GREY
}